import axios from 'axios';
import { API_ENDPOINTS, API_HEADERS } from '../config/api';

// Base API configuration
const API_BASE_URL = API_ENDPOINTS.BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: API_HEADERS,
  withCredentials: true, // Enable sending cookies for guest user sessions
});

// Request interceptor for adding auth tokens
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access - clear all auth tokens
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('temp_token');
      localStorage.removeItem('otp_session_id');
      // You can dispatch logout action here or redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;